import { Injectable, inject } from '@angular/core';

import { WINDOW_TOKEN } from '../window.token';
import { StorageKeyBuilderService } from './storage-key-builder.service';
import { StorageType } from './storage-type.enum';
import { StorageKeyBuilderStrategy } from './storage-key-builder-strategy.enum';
import { BaseStorageService } from './base-storage.service';

/**
 * LocalStorageService
 * Injectable class to provide access and utility methods to browser's local storage
 */
@Injectable({
  providedIn: 'root'
})
export class LocalStorageService extends BaseStorageService {

  constructor() {
    const browserWindow = inject<Window>(WINDOW_TOKEN);
    const storageKeyBuilderService = inject<StorageKeyBuilderService>(StorageKeyBuilderService);

    super(
      browserWindow,
      storageKeyBuilderService,
      StorageKeyBuilderStrategy.KEY_USER,
      StorageType.LOCAL_STORAGE
    );
  }

}
